import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { provideNativeDateAdapter } from '@angular/material/core';

@Component({
  selector: 'app-date-filter-dialog',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  providers: [provideNativeDateAdapter()],
  templateUrl: './date-filter-dialog.component.html',
  styleUrl: './date-filter-dialog.component.scss',
})
export class DateFilterDialogComponent {
  form: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      mode: 'single' | 'range';
      label: string;
      value?: string | Date | null;
      startValue?: string | Date | null;
      endValue?: string | Date | null;
    },
    private dialogRef: MatDialogRef<DateFilterDialogComponent>,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      value: [this.data.value ? this.parseLocalDate(this.data.value) : null],
      start: [this.data.startValue ? this.parseLocalDate(this.data.startValue) : null],
      end: [this.data.endValue ? this.parseLocalDate(this.data.endValue) : null],
    });
  }

  save(): void {
    if (this.data.mode === 'single') {
      const value = this.form.get('value')?.value;

      this.dialogRef.close(value ? this.formatDate(value) : null);
      return;
    }

    const start = this.form.get('start')?.value;
    const end = this.form.get('end')?.value;

    this.dialogRef.close({
      start: start ? this.formatDate(start) : null,
      end: end ? this.formatDate(end) : null,
    });
  }

  clear(): void {
    this.dialogRef.close(null);
  }

  cancel(): void {
    this.dialogRef.close();
  }

  private parseLocalDate(value: string | Date): Date {
    if (value instanceof Date) {
      return value;
    }

    const [year, month, day] = value.split('-').map(Number);

    return new Date(year, month - 1, day);
  }

  private formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }
}